import { systemAdminDashboard } from './reducers';
export default systemAdminDashboard;
